import appI18nInstance from 'i18n';
import { SubscriptionPlanNameEnum } from 'types/users.types';
import formatMoney from 'utils/formatMoney';

const paywall = {
  plans: {
    [SubscriptionPlanNameEnum.small1]: {
      netPrice: 17.5,
    },
    [SubscriptionPlanNameEnum.small12]: {
      netPrice: 15,
    },
  },
  getPlanFeatures: (): Record<
    string,
    {
      features: ({ content: string } | null)[];
    }
  > => ({
    [SubscriptionPlanNameEnum.basic1]: {
      features: [
        {
          content: appI18nInstance.t(
            'subscriptions_screen.features.mobile_access',
          ),
        },
        {
          content: appI18nInstance.t(
            'subscriptions_screen.features.unlimited_docs',
          ),
        },
        {
          content: appI18nInstance.t(
            'subscriptions_screen.features.one_bank_account',
          ),
        },
        {
          content: appI18nInstance.t(
            'subscriptions_screen.features.accountant_access',
          ),
        },
        {
          content: appI18nInstance.t(
            'subscriptions_screen.features.ai_tax_advisor',
          ),
        },
      ],
    },
    [SubscriptionPlanNameEnum.basic12]: {
      features: [
        {
          content: appI18nInstance.t(
            'subscriptions_screen.features.mobile_access',
          ),
        },
        {
          content: appI18nInstance.t(
            'subscriptions_screen.features.unlimited_docs',
          ),
        },
        {
          content: appI18nInstance.t(
            'subscriptions_screen.features.one_bank_account',
          ),
        },
        {
          content: appI18nInstance.t(
            'subscriptions_screen.features.accountant_access',
          ),
        },
        {
          content: appI18nInstance.t(
            'subscriptions_screen.features.ai_tax_advisor',
          ),
        },
      ],
    },
    [SubscriptionPlanNameEnum.free]: {
      features: [
        {
          content: appI18nInstance.t(
            'subscriptions_screen.features.mobile_access',
          ),
        },
        {
          content: appI18nInstance.t(
            'subscriptions_screen.features.five_expenses',
          ),
        },
        {
          content: appI18nInstance.t(
            'subscriptions_screen.features.one_bank_account',
          ),
        },
        {
          content: appI18nInstance.t(
            'subscriptions_screen.features.excel_export',
          ),
        },
      ],
    },
    [SubscriptionPlanNameEnum.pro1]: {
      features: [
        {
          content: appI18nInstance.t(
            'subscriptions_screen.features.automatic_tax_return',
          ),
        },
        {
          content: appI18nInstance.t(
            'subscriptions_screen.features.tax_guarantee_amount',
            { amount: formatMoney(500) },
          ),
        },
        {
          content: appI18nInstance.t(
            'subscriptions_screen.features.mobile_desktop_access',
          ),
        },
        {
          content: appI18nInstance.t(
            'subscriptions_screen.features.bank_accounts',
            {
              numOfAccounts: 5,
            },
          ),
        },
        {
          content: appI18nInstance.t(
            'subscriptions_screen.features.ai_tax_advisor',
          ),
        },
        {
          content: appI18nInstance.t(
            'subscriptions_screen.features.e_invoicing',
          ),
        },
        {
          content: appI18nInstance.t('subscriptions_screen.features.expenses'),
        },
        {
          content: appI18nInstance.t(
            'subscriptions_screen.features.cancel_anytime',
          ),
        },
        {
          content: appI18nInstance.t(
            'subscriptions_screen.features.deductible',
            { percent: 120 },
          ),
        },
      ],
    },
    [SubscriptionPlanNameEnum.pro12]: {
      features: [
        {
          content: appI18nInstance.t(
            'subscriptions_screen.features.automatic_tax_return',
          ),
        },
        {
          content: appI18nInstance.t(
            'subscriptions_screen.features.tax_guarantee_amount',
            { amount: formatMoney(500) },
          ),
        },
        {
          content: appI18nInstance.t(
            'subscriptions_screen.features.mobile_desktop_access',
          ),
        },
        {
          content: appI18nInstance.t(
            'subscriptions_screen.features.bank_accounts',
            {
              numOfAccounts: 5,
            },
          ),
        },
        {
          content: appI18nInstance.t(
            'subscriptions_screen.features.ai_tax_advisor',
          ),
        },
        {
          content: appI18nInstance.t(
            'subscriptions_screen.features.e_invoicing',
          ),
        },
        {
          content: appI18nInstance.t('subscriptions_screen.features.expenses'),
        },
        {
          content: appI18nInstance.t(
            'subscriptions_screen.features.cancel_anytime',
          ),
        },
        {
          content: appI18nInstance.t(
            'subscriptions_screen.features.deductible',
            { percent: 120 },
          ),
        },
      ],
    },
    [SubscriptionPlanNameEnum.small1]: {
      features: [
        {
          content: appI18nInstance.t(
            'subscriptions_screen.features.automatic_tax_return',
          ),
        },
        {
          content: appI18nInstance.t(
            'subscriptions_screen.features.tax_guarantee_amount',
            { amount: formatMoney(500) },
          ),
        },
        {
          content: appI18nInstance.t(
            'subscriptions_screen.features.mobile_desktop_access',
          ),
        },
        {
          content: appI18nInstance.t(
            'subscriptions_screen.features.bank_accounts',
            {
              numOfAccounts: 5,
            },
          ),
        },
        {
          content: appI18nInstance.t(
            'subscriptions_screen.features.ai_tax_advisor',
          ),
        },
        {
          content: appI18nInstance.t(
            'subscriptions_screen.features.e_invoicing',
          ),
        },
        {
          content: appI18nInstance.t('subscriptions_screen.features.expenses'),
        },
        {
          content: appI18nInstance.t(
            'subscriptions_screen.features.cancel_anytime',
          ),
        },
        {
          content: appI18nInstance.t(
            'subscriptions_screen.features.deductible',
            { percent: 120 },
          ),
        },
      ],
    },
    [SubscriptionPlanNameEnum.small12]: {
      features: [
        {
          content: appI18nInstance.t(
            'subscriptions_screen.features.automatic_tax_return',
          ),
        },
        {
          content: appI18nInstance.t(
            'subscriptions_screen.features.tax_guarantee_amount',
            { amount: formatMoney(500) },
          ),
        },
        {
          content: appI18nInstance.t(
            'subscriptions_screen.features.mobile_desktop_access',
          ),
        },
        {
          content: appI18nInstance.t(
            'subscriptions_screen.features.bank_accounts',
            {
              numOfAccounts: 5,
            },
          ),
        },
        {
          content: appI18nInstance.t(
            'subscriptions_screen.features.ai_tax_advisor',
          ),
        },
        {
          content: appI18nInstance.t(
            'subscriptions_screen.features.e_invoicing',
          ),
        },
        {
          content: appI18nInstance.t('subscriptions_screen.features.expenses'),
        },
        {
          content: appI18nInstance.t(
            'subscriptions_screen.features.cancel_anytime',
          ),
        },
        {
          content: appI18nInstance.t(
            'subscriptions_screen.features.deductible',
            { percent: 120 },
          ),
        },
      ],
    },
    [SubscriptionPlanNameEnum.small_max1]: {
      features: [
        {
          content: appI18nInstance.t(
            'subscriptions_screen.features.tax_guarantee_amount',
            { amount: formatMoney(10000) },
          ),
        },
        {
          content: appI18nInstance.t(
            'subscriptions_screen.features.direct_tax_coach',
          ),
        },
        {
          content: appI18nInstance.t(
            'subscriptions_screen.features.unlimited_ai_tax_advisor',
          ),
        },
        {
          content: appI18nInstance.t(
            'subscriptions_screen.features.cancel_anytime',
          ),
        },
        {
          content: appI18nInstance.t(
            'subscriptions_screen.features.bank_accounts',
            {
              numOfAccounts: 10,
            },
          ),
        },
        {
          content: appI18nInstance.t(
            'subscriptions_screen.features.deductible',
            { percent: 120 },
          ),
        },
      ],
    },
    [SubscriptionPlanNameEnum.small_max12]: {
      features: [
        {
          content: appI18nInstance.t(
            'subscriptions_screen.features.tax_guarantee_amount',
            { amount: formatMoney(10000) },
          ),
        },
        {
          content: appI18nInstance.t(
            'subscriptions_screen.features.direct_tax_coach',
          ),
        },
        {
          content: appI18nInstance.t(
            'subscriptions_screen.features.unlimited_ai_tax_advisor',
          ),
        },
        {
          content: appI18nInstance.t(
            'subscriptions_screen.features.cancel_anytime',
          ),
        },
        {
          content: appI18nInstance.t(
            'subscriptions_screen.features.bank_accounts',
            {
              numOfAccounts: 10,
            },
          ),
        },
        {
          content: appI18nInstance.t(
            'subscriptions_screen.features.deductible',
            { percent: 120 },
          ),
        },
      ],
    },
    [SubscriptionPlanNameEnum.pro_max1]: {
      features: [
        {
          content: appI18nInstance.t(
            'subscriptions_screen.features.tax_guarantee_amount',
            { amount: formatMoney(10000) },
          ),
        },
        {
          content: appI18nInstance.t(
            'subscriptions_screen.features.direct_tax_coach',
          ),
        },
        {
          content: appI18nInstance.t(
            'subscriptions_screen.features.unlimited_ai_tax_advisor',
          ),
        },
        {
          content: appI18nInstance.t(
            'subscriptions_screen.features.cancel_anytime',
          ),
        },
        {
          content: appI18nInstance.t(
            'subscriptions_screen.features.bank_accounts',
            {
              numOfAccounts: 10,
            },
          ),
        },
        {
          content: appI18nInstance.t(
            'subscriptions_screen.features.deductible',
            { percent: 120 },
          ),
        },
      ],
    },
    [SubscriptionPlanNameEnum.pro_max12]: {
      features: [
        {
          content: appI18nInstance.t(
            'subscriptions_screen.features.tax_guarantee_amount',
            { amount: formatMoney(10000) },
          ),
        },
        {
          content: appI18nInstance.t(
            'subscriptions_screen.features.direct_tax_coach',
          ),
        },
        {
          content: appI18nInstance.t(
            'subscriptions_screen.features.unlimited_ai_tax_advisor',
          ),
        },
        {
          content: appI18nInstance.t(
            'subscriptions_screen.features.cancel_anytime',
          ),
        },
        {
          content: appI18nInstance.t(
            'subscriptions_screen.features.bank_accounts',
            {
              numOfAccounts: 10,
            },
          ),
        },
        {
          content: appI18nInstance.t(
            'subscriptions_screen.features.deductible',
            { percent: 120 },
          ),
        },
      ],
    },
  }),
};

export default paywall;
